import { useMemo } from 'react';

// Import utils
import { dateKeyFromYmd } from '../../utils/date';

/**
 * useYmdDateKeyMap
 *
 * Builds a stable Map from dateKey (Date.toDateString) to the original YYYY-MM-DD.
 * Returns both the Map and a small accessor helper.
 */
export default function useYmdDateKeyMap(actualYmds: string[]) {
  const map = useMemo(() => {
    const m = new Map<string, string>();
    for (const ymd of actualYmds) {
      m.set(dateKeyFromYmd(ymd), ymd);
    }
    return m;
  }, [actualYmds]);

  const getYmd = (dateKey: string) => map.get(dateKey);

  return { map, getYmd };
}
